import React from "react"
import { useSelector, useDispatch } from "react-redux"

import { EDIT, IDLE } from "const"
import { MarkovVariable } from "server/models"
import {
    PRM_MARKOV_MODEL,
    StoreType,
    MarkovExpressionConvertToView,
    setMarkovVariableDelete,
    addModal,
} from "client/store"
import { hasAccess } from "client/utils"
import {
    Link,
    TableColumn,
    DeleteButton,
} from "client/components"

import EditVariable from "client/pages/markov/variable/edit"

const Columns = () => {
    const variableList = useSelector((state: StoreType) => state.markovVariable.variableList)

    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const editModelAccess = hasAccess(PRM_MARKOV_MODEL, EDIT)

    const columns: TableColumn[] = [
        {
            field: "name",
            header: lang.name,
            sortable: true,
            cellMinWidth: "100px",
            cellMaxWidth: "300px",
            formatter: (variable: MarkovVariable) => (
                editModelAccess
                    ? (
                        <Link
                            href="/#"
                            onClick={() => dispatch(addModal({
                                key: "editVariable",
                                content: <EditVariable variableId={variable.id} />,
                            }))}
                        >
                            {variable.name}
                        </Link>
                    )
                    : variable.name
            ),
        },
        {
            field: "expression",
            header: lang.expression,
            formatter: (variable: MarkovVariable) => (
                MarkovExpressionConvertToView(variable.expression, variableList)
            ),
        },
        {
            field: "order",
            header: lang.order,
            sortable: true,
            cellMinWidth: "100px",
        },
    ]

    if (editModelAccess) {
        columns.push({
            field: "deleteVariable",
            centerAlign: true,
            cellWidth: "46px",
            formatter: (variable: MarkovVariable) => (
                <DeleteButton
                    status={IDLE}
                    onClick={() => dispatch(setMarkovVariableDelete(variable))}
                />
            ),
        })
    }

    return columns
}
export default Columns
